module.exports = __webpack_public_path__ + "static/media/about_abtest_mo.8837184f.png";